
import Vue from 'vue'
import { CheckoutPageModel } from '@ViewModels/CheckoutPageModel'

export default Vue.extend({
   name: 'SchoolAddress',
   computed: {
      modelData(): CheckoutPageModel {
         return this.$store.state.modelData
      },
      schoolName(): string {
         return this.$store.getters.schoolName
      },
      schoolAddress(): string {
         return this.modelData.SchoolId
            ? this.modelData.SchoolAddress
            : this.$store.state.schoolLookup.schoolAddress
      },
   },
})
